﻿export interface IQuestionResponse {
    id: string;
    questionId:string;
    submissionId:string;
    responseInteger: number;
    responseText: string;
    responseCodeCId: number;
    responseBoolean:boolean;
}

export class QuestionResponse {
    id: string;
    questionId: string;
    submissionId: string;
    responseInteger: number;
    responseText: string;
    responseCodeCId: number;
    responseBoolean: boolean;
}

